<template>
  <div>
    <b-card no-body >
      <b-card-body>
        <b-row>
          <b-col
          sm="12"
          md="2"
          class="mt-2"
          >
            <b-form-group>
              <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="obtenerProgRiego"
              :disabled="loading"
              v-b-tooltip.hover.top="'Recargar Datos'"
              >
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
              </b-button>
              <b-button
              variant="gradient-primary"
              size="sm" class="mr-1"
              :disabled="loadingExcel"
              @click="descargarExcel()"
              v-b-tooltip.hover.top="'Descargar Excel'"
              >
                <font-awesome-icon v-if="loadingExcel" icon="fa-solid fa-arrows-rotate" spin />
                <font-awesome-icon v-else icon="fa-solid fa-download"/>
              </b-button>
            </b-form-group>
          </b-col>

          <b-col
          sm="12"
          md="2"
          >
            <b-form-group
            label="Empresa"
            label-for="empresa"
            >
              <v-select
              id="empresa"
              v-model="empresa"
              :options="empresas"
              @input="aplicarFiltros"
              multiple
              class="select-size-sm"
              placeholder="Seleccionar empresa ..."
              />
            </b-form-group>
          </b-col>

          <b-col
          sm="12"
          md="2"
          >
            <b-form-group
            label="Cultivo"
            label-for="cultivo"
            >
              <v-select
                id="cultivo"
                v-model="cultivo"
                :options="cultivos"
                @input="aplicarFiltros"
                multiple
                class="select-size-sm"
                placeholder="Seleccionar cultivo ..."
                />
            </b-form-group>
          </b-col>

          <b-col
          sm="12"
          md="2"
          >
            <b-form-group
            label="Version"
            label-for="version"
            >
              <v-select
              id="version"
              v-model="version"
              :options="versiones"
              @input="aplicarFiltros"
              class="select-size-sm"
              placeholder="Seleccionar version ..."
                />
            </b-form-group>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-table
      hover
      responsive
      small
      sticky-header="58vh"
      class="position-relative"
      :items="itemsFiltro"
      :fields="fields"
      :busy="loading"
      show-empty
      empty-text="No se encontraron datos en esta tabla."
      emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <!-- Template para el campo 'icono' -->
        <template #cell(icono)="data">
          <div class="text-center">
            <font-awesome-icon v-if="data.item === 'aumento'" icon="fa-solid fa-download" />
          </div>
        </template>

        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>


</template>

<script>
  import axiosIns from '../../libs/axios'
  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent'
  import Ripple from 'vue-ripple-directive'
  import { heightTransition } from '@core/mixins/ui/transition'
  import {
    BCard,
    BCardBody,
    BFormInput,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BSpinner,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    VBTooltip,
    BTooltip,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
  } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BCol,
    BFormInput,
    BFormGroup,
    BRow,
    BTable,
    vSelect,
    BSpinner,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    VBTooltip,
    BTooltip,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data: () => ({
    semanas:[],
    items_completo:[],
    items: [],
    itemsFiltro: [],
    loading: false,
    loadingExcel: false,
    loadingExcelBD: false,
    empresa: ["AGROVISION PERÚ S.A.C"],
    empresas: [
      "AGROVISION PERÚ S.A.C",
      "ARENA VERDE",
    ],
    cultivo: [],
    cultivos: [],
    version: [],
    versiones:[],

    fields:[
      // {
      //   key: 'empresa',
      //   label: 'empresa',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      //   tdClass: 'alinear-una-sola-linea text-center',
      //   thClass: 'alinear-medio text-center cabecera',
      // },
      // {
      //   key: 'cultivo',
      //   label: 'cultivo',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      //   tdClass: 'alinear-una-sola-linea text-center',
      //   thClass: 'alinear-medio text-center cabecera',
      // },
      // {
      //   key: 'variedad',
      //   label: 'variedad',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      //   tdClass: 'alinear-una-sola-linea text-center',
      //   thClass: 'alinear-medio text-center cabecera',
      // },
    ],

  }),
  computed: {},
  async mounted() {
    await this.obtenerProgRiego();
  },
  methods: {
    obtenerProgRiego(){
      const yo = this
      yo.loading = true
      const config = {
        method: 'get',
        url: '/pagricolas/riego/reporte_general_variedad/',
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.items_completo = response.data['resultado'];
            yo.items = response.data['resultado'];
            yo.items = yo.calcularCambios(response.data['resultado']);
            yo.aplicarFiltros()

            //Obtengo las semanas para agregarlas como columnas en la tabla
            const semanas = new Set();
            yo.items.forEach(item => {
              Object.keys(item).forEach(key => {
                if (key.startsWith('Semana') && !key.includes('_cambio')) {
                  semanas.add(key);
                }
              });
              // Object.keys(item).forEach(key => {
              //     if (key.startsWith('Semana')) {
              //         semanas.add(key);
              //     }
              // });

              if(!yo.cultivos.includes(item.cultivo)){
                yo.cultivos.push(item.cultivo)
              }

              if(!yo.versiones.includes(item.version)){
                yo.versiones.push(item.version)
              }

            });

            // Convertir el Set a una lista
            let listaDeSemanas = Array.from(semanas);
            yo.semanas = listaDeSemanas

            // for(let i of listaDeSemanas){
            //   let label = i
            //   if(i=='SemanaTotal'){
            //     label='Total'
            //   }
            //   yo.fields.push(
            //     {
            //       key: i,
            //       label: label,
            //       class: 'text-nowrap text-center',
            //       sortable: true,
            //       tdClass: 'alinear-una-sola-linea',
            //       thClass: 'py-0 alinear-medio',
            //       formatter: (value, key, item) => {
            //         // Redondea el valor a tres decimales antes de mostrarlo
            //         return parseFloat(value).toFixed(2);
            //       },
            //     }
            //   )
            // }

            const dynamicFields = listaDeSemanas.map(semana => {
              let label = semana;
              if (semana === 'SemanaTotal') {
                label = 'Total';
              }
              return {
                key: semana,
                label: label,
                class: 'text-nowrap text-center',
                sortable: true,
                tdClass: 'alinear-una-sola-linea',
                thClass: 'py-0 alinear-medio',
                formatter: (value, key, item) => {
                  const resultado = item[`${semana}_cambio`];
                  let icono = '';
                  if (resultado === 'aumento') {
                    icono = '🔼'; // Flecha hacia arriba
                  } else if (resultado === 'disminuyo') {
                    icono = '🔻'; // Flecha hacia abajo
                    // icono = '↓'; // Flecha hacia abajo
                  } else {
                    icono = '➖'; // Raya horizontal
                  }
                  return `${parseFloat(value).toFixed(2)} ${icono}`;
                },
              };
            });

            // Preservar los campos existentes y agregar los campos dinámicos
            yo.fields = [
              // Campos existentes
              {
                key: 'empresa',
                label: 'empresa',
                class: 'text-nowrap text-center',
                sortable: true,
                tdClass: 'alinear-una-sola-linea text-center',
                thClass: 'alinear-medio text-center cabecera',
              },
              {
                key: 'cultivo',
                label: 'cultivo',
                class: 'text-nowrap text-center',
                sortable: true,
                tdClass: 'alinear-una-sola-linea text-center',
                thClass: 'alinear-medio text-center cabecera',
              },
              {
                key: 'variedad',
                label: 'variedad',
                class: 'text-nowrap text-center',
                sortable: true,
                tdClass: 'alinear-una-sola-linea text-center',
                thClass: 'alinear-medio text-center cabecera',
              },
              ...dynamicFields // Campos dinámicos
            ];

          }
        })
        .catch(function (error) {
          console.log(error);
          yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
        })
        .finally(function (){
          yo.loading = false
        })
    },

    calcularCambios(items) {
      return items.map(item => {
        const nuevoItem = { ...item }; // Crear un nuevo objeto basado en item
        const semanas = Object.keys(item).filter(key => key.startsWith('Semana')).sort();
        semanas.forEach((semana, indice) => {
          if (indice === 0) {
            nuevoItem[`${semana}_cambio`] = 'sin-cambio';
          } else {
            const semanaAnterior = semanas[indice - 1];
            const valorActual = parseFloat(item[semana]) || 0;
            const valorAnterior = parseFloat(item[semanaAnterior]) || 0;

            if (valorActual > valorAnterior) {
              nuevoItem[`${semana}_cambio`] = 'aumento';
            } else if (valorActual < valorAnterior) {
              nuevoItem[`${semana}_cambio`] = 'disminuyo';
            } else {
              nuevoItem[`${semana}_cambio`] = 'sin-cambio';
            }
          }
        });
        return nuevoItem;
      });
    },

    aplicarFiltros(){
      const yo = this
      yo.itemsFiltro = []
      let datosFiltrados = []

      // Filtrar los elementos por cultivo y variedad
      datosFiltrados = yo.items_completo.filter(item => {

        const empresaCoincide = yo.empresa.includes(item.empresa);

        const cultivoCoincide = yo.cultivo.length === 0 || yo.cultivo.includes(item.cultivo);
        const versionCoincide = yo.version.length === 0 || yo.version.includes(item.version);

        return empresaCoincide && cultivoCoincide && versionCoincide;
      })

      // Crear un objeto para almacenar las sumas de las semanas
      const sumasSemanas = {};

      // Recorrer los elementos filtrados
      datosFiltrados.forEach(item => {
          Object.keys(item).forEach(key => {
              if (key.startsWith('semana')) {
                  // Si la semana ya existe en el objeto sumasSemanas, sumar el valor
                  // Si no, inicializar la semana con el valor actual
                  sumasSemanas[key] = (sumasSemanas[key] || 0) + item[key];
              }
          });
      });

      // yo.itemsFiltro = datosFiltrados
      yo.itemsFiltro = yo.calcularCambios(datosFiltrados);
      console.log(yo.itemsFiltro)
    },

    descargarExcel(){
      const yo = this
      let datos=[]
      const data = JSON.stringify(
        {
          "datas": yo.itemsFiltro,
          "id_user": yo.id_user,
          "semanas": yo.semanas
        }
      )
      const config = {
        method: 'post',
        url: '/pagricolas/riego/reporte/exportar/variedad/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "Exportar detalle fertilizacion.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Archivo creado',
                icon: 'CheckIcon',
                text: 'El archivo se creó satisfactoriamente.',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en la creación del archivo',
              icon: 'XIcon',
              text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
              variant: 'danger',
            },
          })
        })
        .finally(function () {
          yo.loadingSAD = false
          yo.loadingSSD = false
        });
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

  },
}
</script>

<style lang="scss">

  .alinear-una-sola-linea {
    white-space: nowrap !important;
  }

  .alinear-medio {
    vertical-align: middle !important;
  }

  .cabecera{
    height: 35px;
  }

</style>
